import {useState} from "react"
import {createModel} from "hox"

function useRadioActive() {
    const [radioActive, setRadioActive] = useState(false)

    const toFalse = () => {
        setRadioActive(false)
    }

    const toTrue = () => {
        setRadioActive(true)
    }

    const reverse = () => {
        setRadioActive((prev) => !prev)
    }

    return {
        value: radioActive,
        toTrue,
        toFalse,
        reverse,
    }
}

export default createModel(useRadioActive)
